import * as React from "react";
import * as _ from "lodash";
import { Table } from "react-bootstrap";
import { IActionPosition } from "./models/action-position";
import RccapSwapListRow from "./rccap-swap-list-row";

interface IProps {
    clusterNumber: number,
    positions: IActionPosition[],
    onIncludeAll: (clusterNumber: number) => void,
    onIncludeChange: (clusterNumber: number, positionNumber: number, include: boolean) => void,
    onResponsibleChange: (clusterNumber: number, positionNumber: number, responsible: string) => void
}

class RccapSwapList extends React.Component<IProps, {}> {
    handleIncludeAll = () => {
        this.props.onIncludeAll(this.props.clusterNumber);
    }

    handleIncludeChange = (clusterNumber: number, positionNumber: number, include: boolean) => {
        this.props.onIncludeChange(clusterNumber, positionNumber, include);
    }

    handleResponsibleChange = (clusterNumber: number, positionNumber: number, responsible: string) => {
        this.props.onResponsibleChange(clusterNumber, positionNumber, responsible);
    }

    render = () => {
        const positions = _.orderBy(this.props.positions, [(item: IActionPosition) => {
            return item.position.clusterNumber;
        }, (item: IActionPosition) => {
            return item.position.positionNumber
        }]);

        return (
            <>
                <Table condensed>
                    <thead>
                        <tr>
                            <th style={{ width: "12%" }}>Swap</th>
                            <th>Donor</th>
                            <th>Donor<br/>Center</th>
                            <th style={{ width: "12%" }}>D Center Responsible</th>
                            <th>Recipient</th>
                            <th>Recipient<br/>Center</th>
                            <th style={{ width: "12%" }}>R Center Responsible</th>
                            <th title="Include All/None" onClick={this.handleIncludeAll}>Include</th>
                        </tr>
                    </thead>
                    <tbody>
                        {positions.map((item, index) =>
                            <RccapSwapListRow
                                key={index}
                                index={index}
                                position={item.position}
                                include={item.include}
                                responsible={item.responsible}
                                showInclude={item.showInclude}
                                onIncludeChange={this.handleIncludeChange}
                                onResponsibleChange={this.handleResponsibleChange}
                            />
                        )}
                    </tbody>
                </Table>
            </>
        );
    }
}

export default RccapSwapList;